import { Badge } from "../ui/badge";
import { formatPromptCount } from "@/utils/ai/utils";
import { useSubscriptionInfo } from "@/hooks/pricing/useSubscriptionInfo";
import { useUsageLimits } from "@/hooks/pricing/useUsageLimits";

export function UsageStats() {
  const { usingPrompts, extraPromptsInPackages, renewDisplay } =
    useSubscriptionInfo();

  const { allowedDisplay, remainingUsage } = useUsageLimits();

  return (
    <div className="bg-linear-to-b from-[#1F1F22] to-[#131519] rounded-xl p-4">
      <div className="flex flex-col gap-2">
        <Badge
          variant="outline"
          className="w-fit px-2 py-1 text-[10px] leading-3 text-[#9F9FA4] border-[#2F3035] rounded-[4px] bg-transparent"
        >
          Usage
        </Badge>
        <div className="flex flex-col gap-1">
          <div className="flex items-baseline gap-2">
            <span className="text-[32px] leading-[40px] text-[#F5F5F6] font-normal">
              {usingPrompts
                ? formatPromptCount(remainingUsage.monthlyPromptsLeft ?? 0)
                : remainingUsage.tokensLeftDisplay}
            </span>
            <span className="text-[16px] leading-[26px] text-[#9F9FA4]">
              / {allowedDisplay}
            </span>
          </div>
          <div className="text-[16px] leading-[26px] text-[#F5F5F6]">
            Monthly {usingPrompts ? "credits" : "tokens"} left
          </div>
          <div className="text-[14px] leading-[26px] text-[#9F9FA4]">
            Renews {renewDisplay}
          </div>
          {extraPromptsInPackages > 0 && (
            <div className="mt-1 px-2 pb-1 bg-background-tertiary rounded-[4px] w-fit">
              <span className="text-[10px] leading-3 text-primary">
                + {formatPromptCount(extraPromptsInPackages)} bonus credits
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
